/**
 * Captura a localização do dispositivo para validar o registro remoto.
 * Acompanha as leituras por até 25s e usa a mais precisa (encerra antes se chegar a 15m).
 */
export function obterLocalizacao() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Seu navegador não suporta geolocalização."));
      return;
    }

    let bestPosition = null;
    let watchId = null;
    let timeoutId = null;
    let finalized = false;

    const stopWatching = () => {
      if (watchId !== null) {
        navigator.geolocation.clearWatch(watchId);
        watchId = null;
      }
      if (timeoutId !== null) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
    };

    const finalizar = (position) => {
      if (finalized) return;
      finalized = true;
      stopWatching();
      resolve({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        precisao: position.coords.accuracy,
        geolocalizacao_at: new Date(position.timestamp).toISOString(),
      });
    };

    const handleSuccess = (position) => {
      if (!bestPosition || position.coords.accuracy < bestPosition.coords.accuracy) {
        bestPosition = position;
      }

      if (position.coords.accuracy <= 15) {
        finalizar(position);
      }
    };

    const handleError = (error) => {
      if (finalized) return;

      if (bestPosition) {
        finalizar(bestPosition);
        return;
      }

      stopWatching();
      let msg = "Não foi possível validar o dispositivo.";
      switch (error.code) {
        case error.PERMISSION_DENIED:
          msg =
            "Permissão de acesso ao dispositivo recusada. É necessário conceder as permissões solicitadas.";
          break;
        case error.POSITION_UNAVAILABLE:
          msg = "Sinal ou hardware de validação indisponível.";
          break;
        case error.TIMEOUT:
          msg = "Tempo limite de resposta esgotado na validação.";
          break;
        default:
          break;
      }
      reject(new Error(msg));
    };

    watchId = navigator.geolocation.watchPosition(handleSuccess, handleError, {
      enableHighAccuracy: true,
      timeout: 20000,
      maximumAge: 0,
    });

    timeoutId = setTimeout(() => {
      if (bestPosition) {
        finalizar(bestPosition);
      } else {
        if (finalized) return;
        finalized = true;
        stopWatching();
        reject(new Error("Tempo limite de validação excedido. Tente novamente."));
      }
    }, 25000);
  });
}

export default obterLocalizacao;
